import { useContext, useMemo } from 'react';
import { CompanyAuthContext } from '@contexts/company-auth-context/company-auth-context';
import { FeatureFlagContext } from '@contexts/featureFlag/featureFlag-context';
import { UserPermission } from '@domain/user';
import { useTokenManagement } from '@hooks/auth/use-token-management';

interface UseIsProtectedElementProps {
  permissions: UserPermission[];
  checkEveryPermission?: boolean;
}

export const useIsProtectedElement = ({ permissions, checkEveryPermission = true }: UseIsProtectedElementProps) => {
  const { isCompanyAuthEnabled } = useContext(FeatureFlagContext);
  const { permissions: contextPermissions } = useContext(CompanyAuthContext);
  const { getIsAdmin } = useTokenManagement();

  const isVisible = useMemo(
    () =>
      checkEveryPermission
        ? permissions?.every((permission) => contextPermissions?.includes(permission))
        : permissions?.some((permission) => contextPermissions?.includes(permission)),
    [permissions, checkEveryPermission, contextPermissions]
  );

  return isCompanyAuthEnabled && !getIsAdmin() ? isVisible : true;
};
